<template>
  <div>
    <div class="banner">
      <img src="@/assets/images/contact.jpg">
    </div>
    <HomeContact/>
  </div>
</template>

<script>
import HomeContact from '@/components/HomeContact.vue';
export default {
  components: { HomeContact },
  name: 'ContactUs',  // 组件名称
};
</script>

<style scoped>
.banner{
  width: 100%;
}
.banner img{
  display: block;
  width: 100%;
}
</style>
